import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import cycle from "../../../assets/images/cycle.png";

const Categories = () => {
  return (
    <Box
      margin={{ xs: "25% 0% 15% 0%", sm: "5% 0% 10% 0%" }}
      data-aos={"fade-down"}
    >
      <Box>
        <Typography
          variant="h3"
          fontWeight={700}
          textAlign={"center"}
          paddingBottom={{ xs: "2%", sm: "0%" }}
          color={"#39484E"}
        >
          Size of Grants
        </Typography>
        <Typography
          variant="h6"
          color={"#4f4f4f"}
          padding={{ xs: "6% 0%", sm: "2% 0%" }}
          textAlign={"center"}
        >
          AIR will have between ten and twelve grantees every two years. The
          fund invests up to $150,000 per year for two years. These funds will
          be restricted to project activities aimed at improving product
          development and market acceptance.
        </Typography>
        <Box>
          <Box
            component="img"
            height={{ xs: "", sm: "1350px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={cycle}
            alt={"investment_plan_img"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Categories;
